import type { DataSchema } from 'types';
import { TABLE_CELL_TYPE } from 'types/enums';

export const heliosDataSourcesDataScheme = {
  number: {
    label: 'number',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.id',
  },
  status: {
    label: 'status',
    type: TABLE_CELL_TYPE.STATUS,
    translationKey: 'table.header.status',
  },
  id: {
    label: 'id',
    type: TABLE_CELL_TYPE.ID,
    translationKey: 'table.header.id',
  },
  name: {
    label: 'name',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.name',
  },
  wsUrlBasic: {
    label: 'wsUrlBasic',
    type: TABLE_CELL_TYPE.LINK,
    translationKey: 'table.header.loginUrl',
  },
  wsUrlDomain: {
    label: 'wsUrlDomain',
    type: TABLE_CELL_TYPE.LINK,
    translationKey: 'table.header.domainUrl',
  },
  wsUrlGoogle: {
    label: 'wsUrlGoogle',
    type: TABLE_CELL_TYPE.LINK,
    translationKey: 'table.header.googleUrl',
  },
  wsProfile: {
    label: 'wsProfile',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.profile',
  },
  timeZoneId: {
    label: 'timeZoneId',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.timeZoneId',
  },
} satisfies DataSchema;

export const heliosDataSourcesModalDataScheme = {
  number: {
    label: 'number',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.id',
  },
  id: {
    label: 'id',
    type: TABLE_CELL_TYPE.ID,
    translationKey: 'table.header.id',
  },
  name: {
    label: 'name',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.name',
  },
  wsUrlBasic: {
    label: 'wsUrlBasic',
    type: TABLE_CELL_TYPE.LINK,
    translationKey: 'table.header.loginUrl',
  },
  wsUrlDomain: {
    label: 'wsUrlDomain',
    type: TABLE_CELL_TYPE.LINK,
    translationKey: 'table.header.domainUrl',
  },
  wsUrlGoogle: {
    label: 'wsUrlGoogle',
    type: TABLE_CELL_TYPE.LINK,
    translationKey: 'table.header.googleUrl',
  },
  wsProfile: {
    label: 'wsProfile',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.profile',
  },
  timeZoneId: {
    label: 'timeZoneId',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.timeZoneId',
  },
} satisfies DataSchema;

export const heliosUsersDataScheme = {
  id: {
    label: 'id',
    type: TABLE_CELL_TYPE.ID,
    translationKey: 'table.header.id',
  },
  heliosUserId: {
    label: 'heliosUserId',
    type: TABLE_CELL_TYPE.ID,
    translationKey: 'table.header.heliosUserId',
    hidden: true,
  },
  fullName: {
    label: 'fullName',
    type: TABLE_CELL_TYPE.USERNAME,
    translationKey: 'user.contacts.contacts.person',
  },
  email: {
    label: 'email',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'user.contacts.contacts.email',
  },
  phoneNumber: {
    label: 'phoneNumber',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'user.contacts.contacts.phoneNumber',
  },
  organization: {
    label: 'organization',
    type: TABLE_CELL_TYPE.NAME_ARRAY,
    translationKey: 'user.contacts.contacts.organization',
  },
} satisfies DataSchema;
